export const listControl = [
   {
      name: "Họ và tên",
      code: "{{full_name}}"
   },
   {
      name: "Tên trang",
      code: "{{page_name}}"
   },
   {
      name: "Tên chiến dịch",
      code: "{{campaign_name}}"
   },
   {
      name: "Chi tiết sản phẩm",
      code: "{{product_detail}}"
   }
];

export const FULL_NAME = {
   name: "Họ và tên",
   code: "{{user_full_name}}"
}

export const PAGE_NAME = {
   name: "Tên trang",
   code: "{{page_name}}"
}

export const CAMPAIGN_NAME = {
   name: "Tên chiến dịch",
   code: "{{campaign_name}}"
}

export const NAME = {
   name: "Tên",
   code: "{{user_first_name}}"
}

export const SURNAME = {
   name: "Họ",
   code: "{{user_last_name}}"
}

export const LIVE_CAMPAIGN_NAME = {
   name: "Tên chiến dịch",
   code: "{{live_campaign_name}}"
}

export const PRODUCT_INFO = {
   name: "Chi tiết sản phẩm",
   code: "{{product_info}}"
}

export const PRODUCT_KEYWORD = {
   name: "Mã sản phẩm",
   code: "{{product_keyword}}"
}